import { Navigate, Route, Routes } from 'react-router-dom';

import { Login } from './Login';
import { Session } from './Session';
import { ConfirmEmail } from './ConfirmEmail';
import { VerifyOTP } from './VerifyOTP';
import { Register } from './Register';

export const AuthRoutes = () => {
  return (
    <Routes>
      {/* <Route path="verify-otp" element={<VerifyOTP />} /> */}
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      {/* <Route path="register/confirm/:code" element={<ConfirmEmail />} /> */}
      <Route path="session/timeout" element={<Session />} />
    </Routes>
  );
};
